import { useState, useContext, useEffect, useMemo } from 'react'
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  MenuItem,
  FormControlLabel,
  Switch,
  Menu,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Header from './components/header/Header'
import Pie from './components/pie/Pie'
import TableList from './components/table/TableList'
// import { HighlightItemData } from '@mui/x-charts/context'
import React from 'react'
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/DashboardNavbar'
import SoftBox from 'components/SoftBox'
import RiskProfile from './components/riskprofile'
import TSPGoals from './components/goals'
import { IntakeContext } from 'context/IntakeContext'

import tspPlaceholder from 'assets/images/tspPlaceholder.png'
import squaresbackground from 'assets/images/squares.png'

import MoreVertIcon from '@mui/icons-material/MoreVert'
import EditIcon from '@mui/icons-material/Edit'

import { renderFormField } from 'utils/forms/renderFormField'
import Strategy from './components/strategy'
import { TSPDetails } from './components/details'

import { motion, AnimatePresence } from 'framer-motion'

import theme from 'assets/theme'

import Card from 'atoms/Card'
import Banner from 'atoms/Banner'
import Gauge from 'atoms/Gauge'

import meeting from 'assets/images/icons/meeting-background.svg'
import ScoreCard from 'components/ScoreCard'
import { useRPQScore } from 'layouts/authenticated/pages/dashboard/hooks/useRPQScore'
import { useModal } from 'components/modals'
import { riskProfiles } from 'components/modals/RiskAssessment/risk-profiles'

const MotionBox = motion(Box)

function NewTsp({
  isDemo = false,
  isDisplayOnly = false,
  hideLabels = true,
  showExposed = false,
  isUnlocked = false,
}) {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const rpqScore = useRPQScore()
  const riskWeightedScore = intakeState?.riskAssessment?.manualRiskLevel
    ? intakeState?.riskAssessment?.manualRiskLevel
    : rpqScore?.weightedScore
  const isRiskAssessmentComplete = intakeState?.riskAssessment?.isComplete
  const { openModal } = useModal()
  const currentRiskLevel =
    riskWeightedScore || intakeState?.riskAssessment?.manualRiskLevel
  const profile = riskProfiles.find((p) => p.riskLevel === currentRiskLevel)
  const { displayName, image, subtitle, accentHex } = profile || {}

  const [data, setData] = useState([])

  // console.log('TEST')
  // console.log(data)

  const [selected, setSelected] = useState(null)
  const [showType, setShowType] = useState('TSP Total')

  const [isLoading, setIsLoading] = useState(false)
  const [tab, setTab] = useState(0)
  const [tspDetailsOpen, setTSPDetailsOpen] = useState(false)

  const [openTest, setOpenTest] = useState(0)
  const tspBalance =
    (intakeState.tspBalance ?? 0) + (intakeState.tspRothBalance ?? 0)

  const tspRoth = intakeState.tspRothBalance ?? 0

  const rothPercent = tspBalance > 0 ? (tspRoth / tspBalance) * 100 : 0
  const traditionalPercent = 100 - rothPercent

  const lifecycleFundBreakdowns = {
    tspLIncome: {
      tspGFund: 67.99,
      tspFFund: 5.51,
      tspCFund: 13.79,
      tspSFund: 3.43,
      tspIFund: 9.28,
    },
    tspL2025: {
      tspGFund: 65.1,
      tspFFund: 5.64,
      tspCFund: 15.21,
      tspSFund: 3.81,
      tspIFund: 10.24,
    },
    tspL2030: {
      tspGFund: 34.25,
      tspFFund: 5.63,
      tspCFund: 31.23,
      tspSFund: 7.85,
      tspIFund: 21.04,
    },
    tspL2035: {
      tspGFund: 27.5,
      tspFFund: 6.56,
      tspCFund: 34.23,
      tspSFund: 8.63,
      tspIFund: 23.08,
    },
    tspL2040: {
      tspGFund: 21.29,
      tspFFund: 6.96,
      tspCFund: 37.22,
      tspSFund: 9.42,
      tspIFund: 25.11,
    },
    tspL2045: {
      tspGFund: 15.92,
      tspFFund: 7.33,
      tspCFund: 39.76,
      tspSFund: 10.13,
      tspIFund: 26.86,
    },
    tspL2050: {
      tspGFund: 11.1,
      tspFFund: 7.15,
      tspCFund: 42.33,
      tspSFund: 10.81,
      tspIFund: 28.61,
    },
    tspL2055: {
      tspGFund: 0.54,
      tspFFund: 0.45,
      tspCFund: 51.25,
      tspSFund: 13.11,
      tspIFund: 34.65,
    },
    tspL2060: {
      tspGFund: 0.48,
      tspFFund: 0.51,
      tspCFund: 51.25,
      tspSFund: 13.11,
      tspIFund: 34.65,
    },
    tspL2065: {
      tspGFund: 0.4,
      tspFFund: 0.59,
      tspCFund: 51.25,
      tspSFund: 13.11,
      tspIFund: 34.65,
    },
    tspL2070: {
      tspGFund: 0.36,
      tspFFund: 0.64,
      tspCFund: 51.48,
      tspSFund: 12.87,
      tspIFund: 34.65,
    },
    tspL2075: {
      tspGFund: 0.36,
      tspFFund: 0.64,
      tspCFund: 51.48,
      tspSFund: 12.87,
      tspIFund: 34.65,
    },
  }

  const fundColors = {
    tspGFund: '#DD2845',
    tspFFund: '#B96EDD',
    tspCFund: '#60BE64',
    tspSFund: '#FD9446',
    tspIFund: '#2370ED',
    tspLIncome: '#344767',
    tspL2025: '#344767',
    tspL2030: '#344767',
    tspL2035: '#344767',
    tspL2040: '#344767',
    tspL2045: '#344767',
    tspL2050: '#344767',
    tspL2055: '#344767',
    tspL2060: '#344767',
    tspL2065: '#344767',
    tspL2070: '#344767',
    tspL2075: '#344767',
  }

  const parsedTspAllocation =
    typeof intakeState.tspAllocation === 'string'
      ? JSON.parse(intakeState.tspAllocation)
      : intakeState.tspAllocation || {}

  const showLookThrough = Object.entries(parsedTspAllocation).some(
    ([key, value]) => key.startsWith('tspL') && value > 0
  )

  const computedRisk = (lFundName, baseRiskMap) => {
    const breakdown = lifecycleFundBreakdowns[lFundName]
    if (!breakdown) return null

    let totalRisk = 0
    Object.entries(breakdown).forEach(([fundName, percent]) => {
      const risk = baseRiskMap[fundName] ?? 0
      totalRisk += (percent / 100) * risk
    })

    return Number(totalRisk.toFixed(2))
  }

  const initialAllocation = useMemo(() => {
    const base = {
      tspGFund: {
        label: 'G Fund',
        percentage: parsedTspAllocation.tspGFund ?? '',
        selected: parsedTspAllocation.tspGFund ? true : false,
        risk: 1,
        color: '#DD2845',
      },
      tspFFund: {
        label: 'F Fund',
        percentage: parsedTspAllocation.tspFFund ?? '',
        selected: parsedTspAllocation.tspFFund ? true : false,
        risk: 20,
        color: '#B96EDD',
      },
      tspCFund: {
        label: 'C Fund',
        percentage: parsedTspAllocation.tspCFund ?? '',
        selected: parsedTspAllocation.tspCFund ? true : false,
        risk: 75,
        color: '#60BE64',
      },
      tspSFund: {
        label: 'S Fund',
        percentage: parsedTspAllocation.tspSFund ?? '',
        selected: parsedTspAllocation.tspSFund ? true : false,
        risk: 99,
        color: '#FD9446',
      },
      tspIFund: {
        label: 'I Fund',
        percentage: parsedTspAllocation.tspIFund ?? '',
        selected: parsedTspAllocation.tspIFund ? true : false,
        risk: 86,
        color: '#2370ED',
      },
    }

    // Extract base risk map
    const baseRiskMap = Object.fromEntries(
      Object.entries(base).map(([key, val]) => [key, val.risk])
    )

    const lFunds = [
      'tspLIncome',
      'tspL2025',
      'tspL2030',
      'tspL2035',
      'tspL2040',
      'tspL2045',
      'tspL2050',
      'tspL2055',
      'tspL2060',
      'tspL2065',
      'tspL2070',
      'tspL2075',
    ]

    //add in the L fund flag
    base['tspLFund'] = {
      label: 'L Funds',
      selected: lFunds.some((key) => Number(parsedTspAllocation[key] ?? 0) > 0),
      color: '#344767',
    }

    lFunds.forEach((key) => {
      base[key] = {
        label: key.replace('tspL', 'L ').replace('Fund', 'Fund').trim(),
        percentage: parsedTspAllocation[key] ?? '',
        selected: parsedTspAllocation[key] ? true : false,
        color: '#344767',
        risk: computedRisk(key, baseRiskMap),
      }
    })

    return base
  }, [parsedTspAllocation])

  useEffect(() => {
    // console.log(intakeState)
    const tspBalance =
      (intakeState.tspBalance ?? 0) + (intakeState.tspRothBalance ?? 0)

    // Step 1: Build raw allocation
    let allocationAccumulator = {}

    Object.entries(parsedTspAllocation).forEach(([fund, percentage]) => {
      if (percentage <= 0) return

      if (tab === 1 && lifecycleFundBreakdowns[fund]) {
        // Look through: decompose L Fund
        const breakdown = lifecycleFundBreakdowns[fund]
        Object.entries(breakdown).forEach(([underlyingFund, percent]) => {
          allocationAccumulator[underlyingFund] =
            (allocationAccumulator[underlyingFund] ?? 0) +
            (percentage * percent) / 100
        })
      } else {
        // Regular fund, or tab === 0
        allocationAccumulator[fund] =
          (allocationAccumulator[fund] ?? 0) + percentage
      }
    })

    // Step 2: Convert to data array
    let activeFunds = Object.entries(allocationAccumulator)
      .filter(([_, percent]) => percent > 0)
      .map(([fundKey, percent]) => ({
        key: fundKey,
        title: fundKey
          .replace('tsp', '')
          .replace(/([A-Z])/g, ' $1')
          .trim(),

        value: Math.round((percent / 100) * tspBalance),
        percent,
        risk: initialAllocation[fundKey]?.risk,
        color: fundColors[fundKey] ?? '#ccc',
      }))

    const preferredOrder = Object.keys(fundColors)

    // Sort by fundColors key order
    activeFunds.sort((a, b) => {
      const getKey = (title) => {
        const normalized = `tsp${title.replace(/\s/g, '')}`
        return normalized
      }
      return (
        preferredOrder.indexOf(getKey(a.title)) -
        preferredOrder.indexOf(getKey(b.title))
      )
    })

    // Step 3: Handle "Unknown" remainder if mix < 97%
    const totalMixPercent = activeFunds.reduce((sum, f) => sum + f.percent, 0)

    if (isDemo && activeFunds.length === 0) {
      const demoFunds = ['tspGFund', 'tspCFund', 'tspL2030']
      const percentEach = 100 / demoFunds.length
      activeFunds = demoFunds.map((key) => ({
        key,
        title: initialAllocation[key]?.label ?? key.replace('tsp', ''),
        percent: percentEach,
        value: (percentEach / 100) * (tspBalance || 100000), // fallback balance if 0
        risk: initialAllocation[key]?.risk,
        color: fundColors[key] ?? '#ccc',
        __demo: true,
      }))
    } else if (!isDemo && totalMixPercent < 97) {
      const unknownPercent = 100 - totalMixPercent
      const unknownValue = (unknownPercent / 100) * tspBalance
      activeFunds.push({
        title: 'Unknown',
        value: unknownValue,
        percent: unknownPercent,
        color: '#B0B0B0',
      })
    }

    if (isDisplayOnly) {
      setTab(1)
    }

    if (showExposed) {
      const gFund = activeFunds.find((fund) => fund.title === 'G Fund')
      const exposedFunds = activeFunds.filter((fund) => fund.title !== 'G Fund')

      const displayOnlyData = []

      if (gFund) {
        displayOnlyData.push(gFund)
      }

      if (exposedFunds.length > 0) {
        displayOnlyData.push({
          title: 'Exposed to Market Loss',
          color: '#B0B0B0',
          value: Math.round(
            exposedFunds.reduce((sum, fund) => sum + (fund.value || 0), 0)
          ),
        })
      }

      setData(displayOnlyData)
    } else {
      if (!tspDetailsOpen) {
        setData(activeFunds)
        setIsLoading(false)
      }
    }
  }, [intakeState, tab, tspDetailsOpen])

  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const tableMenuOpen = Boolean(anchorEl)
  const handleTableMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleTableMenuClose = () => {
    setAnchorEl(null)
  }

  const handleOpenModal = () => {
    setTSPDetailsOpen(true)
    setIsLoading(true)
  }

  return (
    <>
      {isDemo ? (
        <>
          {isUnlocked ? (
            <>
              <Card>
                <Box
                  p={2}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Box
                    sx={{
                      alignSelf: 'flex-end',
                    }}
                  >
                    <ToggleButtonGroup
                      value={tab}
                      exclusive
                      onChange={(e) => {
                        if (e.target.value == 1) {
                          setTab(1)
                        } else {
                          setTab(0)
                        }
                      }}
                      aria-label="High Level"
                      sx={{
                        height: '36px',
                        alignSelf: 'center',
                        borderRadius: '36px',
                        background: '#A3A7AA',
                        border: '3px solid #A3A7AA',
                      }}
                    >
                      <ToggleButton
                        sx={{
                          borderRadius: '36px !important',
                          border: 'none',
                          color: '#fff',
                          textTransform: 'capitalize',
                          fontWeight: '500',
                          letterSpacing: '0.5px',
                          '&.Mui-selected': {
                            backgroundColor: '#fff !important',
                            color: '#75787B',
                            fontWeight: '600',
                          },
                        }}
                        value={0}
                      >
                        High Level
                      </ToggleButton>

                      <ToggleButton
                        sx={{
                          borderRadius: '36px !important',
                          border: 'none',
                          color: '#fff',
                          textTransform: 'capitalize',
                          fontWeight: '500',
                          letterSpacing: '0.5px',
                          '&.Mui-selected': {
                            backgroundColor: '#fff !important',
                            color: '#75787B',
                            fontWeight: '600',
                          },
                        }}
                        value={1}
                      >
                        Look Through
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Box>

                <Pie
                  selected={selected}
                  onSelectionChange={setSelected}
                  viewSelection={showType}
                  data={data}
                  redact={false}
                />

                <TableList
                  onSelectionChange={setSelected}
                  selected={selected}
                  data={data}
                  lifecycleFundBreakdowns={lifecycleFundBreakdowns}
                  initialAllocation={initialAllocation}
                  redact={false}
                />
              </Card>
              {/* <Card>
                <Banner
                  color={'green'}
                  type={'banner'}
                  actionText="TALK TO AN ADVISOR"
                  title="RECOMMENDED TSP STRATEGY"
                  description={`Boost your score to`}
                />
              </Card> */}
            </>
          ) : (
            <Card>
              <Pie
                selected={selected}
                onSelectionChange={setSelected}
                viewSelection={showType}
                data={data}
                redact={isDemo}
              />

              <TableList
                onSelectionChange={setSelected}
                selected={selected}
                data={data}
                lifecycleFundBreakdowns={lifecycleFundBreakdowns}
                initialAllocation={initialAllocation}
                redact={isDemo}
              />
            </Card>
          )}
        </>
      ) : (
        <>
          {isDisplayOnly ? (
            <>
              <Pie
                selected={selected}
                onSelectionChange={setSelected}
                viewSelection={showType}
                data={data}
                hideLabels={hideLabels}
              />
            </>
          ) : (
            <>
              <DashboardLayout>
                <Box
                  px={{
                    xs: 4,
                    sm: 4,
                    md: 4,
                    lg: 6,
                    xl: 6,
                    xxl: 6,
                    test: 6,
                    xl3: 6,
                  }}
                  pb={6}
                >
                  <Grid item xs={12} mb={4} mt={8} display={'flex'}>
                    <Typography
                      fontWeight="400"
                      fontSize="28px"
                      textAlign="left"
                      color="#262627"
                    >
                      <Box sx={{ display: 'inline-block', fontWeight: 600 }}>
                        Thrift Savings Plan
                      </Box>{' '}
                      - Check up on your investments
                    </Typography>
                  </Grid>

                  <TSPDetails
                    open={tspDetailsOpen}
                    handleClose={() => {
                      setTSPDetailsOpen(false)
                      handleTableMenuClose()
                      setIsLoading(false)
                    }}
                    initialAllocation={initialAllocation}
                  />

                  <Grid container columnSpacing={6} rowSpacing={2}>
                    {Object.values(data).some(
                      (fund) =>
                        fund.title !== 'Unknown' &&
                        fund.percent > 0 &&
                        (intakeState?.tspBalance || 0) +
                          (intakeState?.tspRothBalance || 0) >
                          0
                    ) ? (
                      <>
                        <Grid mb={6} item xs={12} xl={6}>
                          <motion.div
                            style={{ display: 'block' }}
                            // layout
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.4, ease: 'easeInOut' }}
                          >
                            <Card>
                              <Box
                                p={2}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                <Box
                                  sx={{
                                    alignSelf: 'flex-end',
                                  }}
                                >
                                  <ToggleButtonGroup
                                    value={tab}
                                    exclusive
                                    onChange={(e) => {
                                      if (e.target.value == 1) {
                                        setTab(1)
                                      } else {
                                        setTab(0)
                                      }
                                    }}
                                    aria-label="High Level"
                                    sx={{
                                      height: '36px',
                                      alignSelf: 'center',
                                      borderRadius: '36px',
                                      background: '#A3A7AA',
                                      border: '3px solid #A3A7AA',
                                      display: showLookThrough
                                        ? 'inline-flex'
                                        : 'none',
                                    }}
                                  >
                                    <ToggleButton
                                      sx={{
                                        borderRadius: '36px !important',
                                        border: 'none',
                                        color: '#fff',
                                        textTransform: 'capitalize',
                                        fontWeight: '500',
                                        letterSpacing: '0.5px',
                                        '&.Mui-selected': {
                                          backgroundColor: '#fff !important',
                                          color: '#75787B',
                                          fontWeight: '600',
                                        },
                                      }}
                                      value={0}
                                    >
                                      High Level
                                    </ToggleButton>

                                    <ToggleButton
                                      sx={{
                                        borderRadius: '36px !important',
                                        border: 'none',
                                        color: '#fff',
                                        textTransform: 'capitalize',
                                        fontWeight: '500',
                                        letterSpacing: '0.5px',
                                        '&.Mui-selected': {
                                          backgroundColor: '#fff !important',
                                          color: '#75787B',
                                          fontWeight: '600',
                                        },
                                      }}
                                      value={1}
                                    >
                                      Look Through
                                    </ToggleButton>
                                  </ToggleButtonGroup>
                                  <IconButton
                                    id="basic-button"
                                    aria-controls={
                                      open ? 'basic-menu' : undefined
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleTableMenuClick}
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                  <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={tableMenuOpen}
                                    onClose={handleTableMenuClose}
                                    MenuListProps={{
                                      'aria-labelledby': 'basic-button',
                                    }}
                                  >
                                    <MenuItem onClick={() => handleOpenModal()}>
                                      <IconButton
                                        sx={{
                                          padding: '1px 16px 2px 10px',
                                          color: '#344767',
                                        }}
                                      >
                                        <EditIcon />
                                      </IconButton>
                                      Edit Values
                                    </MenuItem>
                                  </Menu>
                                </Box>
                              </Box>

                              <Pie
                                selected={selected}
                                onSelectionChange={setSelected}
                                viewSelection={showType}
                                data={data}
                                hideLabels={hideLabels}
                              />

                              {/* ROTH / TRADITIONAL */}
                              <Box sx={{ width: '65%', margin: 'auto' }}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    gap: 1,
                                  }}
                                >
                                  <Box
                                    onClick={() =>
                                      setShowType((prev) =>
                                        prev === 'TSP Roth'
                                          ? 'TSP Total'
                                          : 'TSP Roth'
                                      )
                                    }
                                    sx={{
                                      cursor: 'pointer',
                                      width: `${rothPercent}%`,
                                      minWidth: '5%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <Typography
                                      variant="body1Medium"
                                      color="#A3A7AA"
                                    >
                                      Roth
                                    </Typography>

                                    <MotionBox
                                      component="div"
                                      sx={{
                                        // width: `${rothPercent}%`,
                                        width: '100%',
                                        mt: 0.5,
                                        transformOrigin: 'top',

                                        height: 15,
                                        backgroundColor: '#75787B',
                                        borderTopLeftRadius: 20,
                                        borderBottomLeftRadius: 20,
                                        transition: 'width 0.3s ease',
                                      }}
                                      animate={{
                                        scaleY:
                                          showType === 'TSP Roth' ? 20 / 15 : 1,
                                      }}
                                      whileHover={{
                                        scaleY:
                                          showType === 'TSP Roth'
                                            ? 25 / 15
                                            : 20 / 15,
                                      }}
                                      transition={{
                                        duration: 0.25,
                                        type: 'spring',
                                        stiffness: 300,
                                        damping: 21,
                                      }}
                                    />
                                  </Box>

                                  <Box
                                    onClick={() =>
                                      setShowType((prev) =>
                                        prev === 'TSP Total'
                                          ? 'TSP Traditional'
                                          : 'TSP Total'
                                      )
                                    }
                                    sx={{
                                      cursor: 'pointer',
                                      width: `${traditionalPercent}%`,
                                      minWidth: '5%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'flex-end',
                                    }}
                                  >
                                    <Typography
                                      variant="body1Medium"
                                      color="#A3A7AA"
                                      align="right"
                                    >
                                      Traditional
                                    </Typography>

                                    <MotionBox
                                      component="div"
                                      sx={{
                                        width: '100%',
                                        mt: 0.5,
                                        transformOrigin: 'top',

                                        height: 15,
                                        backgroundColor: '#D2D6DA',
                                        borderTopRightRadius: 20,
                                        borderBottomRightRadius: 20,
                                        transition: 'width 0.3s ease',
                                      }}
                                      animate={{
                                        scaleY:
                                          showType === 'TSP Traditional'
                                            ? 20 / 15
                                            : 1,
                                      }}
                                      whileHover={{
                                        scaleY:
                                          showType === 'TSP Traditional'
                                            ? 25 / 15
                                            : 20 / 15,
                                      }}
                                      transition={{
                                        duration: 0.25,
                                        type: 'spring',
                                        stiffness: 300,
                                        damping: 21,
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Box>

                              <TableList
                                onSelectionChange={setSelected}
                                selected={selected}
                                data={data}
                                lifecycleFundBreakdowns={
                                  lifecycleFundBreakdowns
                                }
                                initialAllocation={initialAllocation}
                              />
                            </Card>
                          </motion.div>
                        </Grid>

                        {/* <Grid
                item
                xs={12}
                xl={12}
                xxl={6}
                rowSpacing={6}
                columnSpacing={6}
              >
                <Grid item xs={12} xl={12}>
                  <Banner
                    color={'green'}
                    type={'banner'}
                    actionText="TALK TO AN ADVISOR"
                    title="RECOMMENDED TSP STRATEGY"
                    description={`Boost your score to`}
                    content={
                      <Box sx={{ marginTop: 2, marginLeft: -6 }}>
                        <Gauge color={'white'} value={94} />
                      </Box>
                    }
                  />
                </Grid>
                <Grid item mt={6} xs={12} xl={12}>
                  <Typography
                    display={'flex'}
                    align={'left'}
                    variant={'body2Fun'}
                    color={'#495057'}
                    mb={2}
                    letterSpacing={0.32}
                  >
                    RISK PROFILE
                  </Typography>

                  <RiskProfile setOpen={setOpenTest} />
                </Grid>

                <Grid item mt={6} xs={12} xl={12}>
                  <Typography
                    display={'flex'}
                    align={'left'}
                    variant={'body2Fun'}
                    color={'#495057'}
                    mb={2}
                    letterSpacing={0.32}
                  >
                    TSP GOALS
                  </Typography>
                  <TSPGoals />
                </Grid>

                <Grid item mt={6} xs={12} xl={12}>
                  <Banner
                    color={'blue'}
                    type={'banner'}
                    actionText="TALK TO AN ADVISOR"
                    title=""
                    description="Schedule a meeting"
                    subText="Click here to speak with a PARCO team member"
                    content={
                      <>
                        <img
                          style={{
                            objectFit: 'cover',
                            paddingTop: '16px',
                            width: '100px',
                          }}
                          src={meeting}
                        />
                      </>
                    }
                  />
                </Grid>
              </Grid> */}
                      </>
                    ) : (
                      <Grid item xs={12} xl={6}>
                        <motion.div
                          style={{ display: 'block' }}
                          // layout
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.4, ease: 'easeInOut' }}
                        >
                          <Card
                            sx={{
                              textAlign: 'center',
                              // boxShadow: 0,
                              // borderRadius: 2,
                              // border: '1px solid #D2D6DA',
                            }}
                          >
                            <Box
                              p={{ xs: 3, md: 6 }}
                              sx={{
                                position: 'relative', // establish positioning context
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundImage: `url(${squaresbackground})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                borderRadius: '24px',
                                '&::before': {
                                  content: '""',
                                  position: 'absolute',
                                  width: '100%',
                                  height: '100%',
                                  background:
                                    'linear-gradient(to bottom,  rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%,rgba(255,255,255,1) 100%)',
                                  top: 0,
                                  left: 0,
                                },
                              }}
                            >
                              <Box sx={{ position: 'relative' }}>
                                <Box
                                  sx={{
                                    borderRadius: '24px',

                                    '&::after': {
                                      content: '""',
                                      position: 'absolute',
                                      width: '100%',
                                      height: '100%',
                                      background:
                                        'linear-gradient(to bottom,  rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%,rgba(255,255,255,1) 80%)',
                                      top: 0,
                                      left: 0,
                                    },
                                  }}
                                >
                                  <Box
                                    sx={{
                                      position: 'relative',
                                      width: '100%',
                                      maxWidth: 420,
                                      height: 550,
                                      overflow: 'hidden',
                                      borderRadius: 2,
                                    }}
                                  >
                                    <img
                                      src={tspPlaceholder}
                                      alt="TSP Placeholder"
                                      style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                        objectPosition: 'top',
                                        display: 'block',
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                              <Box>
                                <Typography
                                  variant="h3"
                                  textTransform="capitalize"
                                  fontSize={{ xs: '20px', md: '24px' }}
                                  color="#262627"
                                >
                                  View My TSP Breakdown
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  maxWidth: '80%',
                                  margin: 'auto',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  sx={{ lineHeight: 1.2 }}
                                  fontSize={{ xs: '16px', md: '18px' }}
                                  my={2}
                                  color="#495057"
                                  textAlign="center"
                                >
                                  Connect your TSP account or provide specific
                                  TSP fund information to see your breakdown.
                                </Typography>
                                <Button
                                  variant="parcoRounded"
                                  onClick={() => handleOpenModal()}
                                >
                                  Access My TSP Breakdown
                                </Button>
                              </Box>
                            </Box>
                          </Card>
                        </motion.div>
                      </Grid>
                    )}
                    {isRiskAssessmentComplete ? (
                      <Grid item xs={12} xl={6}>
                        <motion.div
                          layout
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.4, ease: 'easeInOut' }}
                          onClick={() =>
                            openModal('riskProfileModal', {
                              currentRiskLevel: currentRiskLevel,
                            })
                          }
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 2,
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative',
                              width: '100%',
                              cursor: 'pointer',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                height: '24px',
                                width: '100%',
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins, sans-serif',
                                  fontSize: 16,
                                  fontWeight: 600,
                                  color: '#495057',
                                  letterSpacing: '0.32px',
                                  lineHeight: 1,
                                  marginRight: '-10px',
                                }}
                              >
                                RISK PROFILE
                              </Typography>
                            </Box>

                            {/* Content Tile */}
                            <Box
                              sx={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: '20px',
                                padding: '24px',
                                boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                                width: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: '#f0f4f8',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '94.5px',
                                    height: '94.5px',
                                  }}
                                >
                                  <img
                                    src={image}
                                    alt={displayName}
                                    style={{
                                      width: '78.5px',
                                      height: '78.5px',
                                      objectFit: 'cover',
                                    }}
                                  />
                                </Box>
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  gap={1}
                                  flex={1}
                                  textAlign="left"
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Inter, sans-serif',
                                      fontSize: {
                                        xxs: 16,
                                        xs: 20,
                                        md: 24,
                                        lg: 24,
                                      },
                                      fontWeight: 600,
                                      lineHeight: 1.33,
                                      color: '#262627',
                                    }}
                                  >
                                    {displayName} Investor
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Inter, sans-serif',
                                      fontSize: {
                                        xxs: 14,
                                        xs: 15,
                                        md: 20,
                                        lg: 20,
                                      },
                                      fontWeight: 600,
                                      lineHeight: 1.5,
                                      color: accentHex,
                                    }}
                                  >
                                    {subtitle}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Inter, sans-serif',
                                      fontSize: 14,
                                      fontWeight: 400,
                                      lineHeight: 1.5,
                                      color: '#A3A7AA',
                                    }}
                                  >
                                    Calculated from questionnaire responses
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </motion.div>
                      </Grid>
                    ) : (
                      <Grid item xs={12} xl={6}>
                        <>
                          <motion.div
                            key={7}
                            layout
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.4, ease: 'easeInOut' }}
                          >
                            <Banner
                              color={''}
                              type={'unlock'}
                              actionText="TAKE THE RISK ASSESSMENT QUIZ"
                              clickAction={() => {
                                openModal('riskAssessmentQuiz', {})
                              }}
                              title="UNLOCK TILE"
                              description="Risk Assessment Quiz"
                              subText=""
                              content=""
                            />
                          </motion.div>
                        </>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </DashboardLayout>
            </>
          )}
        </>
      )}
    </>
  )
}

export default NewTsp
